module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/lv-2ce7f836390f846b1359abaa9ba4e8bc.svg";